export default {
    dataBegin(state) {
        state.loading = true;
        state.error = false;
    },
    dataSuccess(state, data) {
        state.data = data;
        state.loading = false;
    },
    dataErr(state, err) {
        state.loading = false;
        state.error = err;
    },
};
